import { useState, Fragment } from "react";
import { Switch, Dialog, Transition, TransitionChild, DialogPanel } from '@headlessui/react';
import ClientService from "../../../rest/clientService";
import { toast } from "react-toastify";

const PreferencesTab = ({ clientPreferences, setClientPreferences }) => {
    const [showPin, setShowPin] = useState(false);
    const [isEditingPin, setIsEditingPin] = useState(false);
    const [newPin, setNewPin] = useState("");

    const toggleFields = [
        { label: 'Mostrar fotos de perfil', key: 'enable_profile_pictures' },
        { label: 'Mostrar imagens de produtos', key: 'enable_product_images' },
        { label: 'Enviar notificações de compra por email', key: 'enable_send_notifications' },
        { label: 'Enviar credenciais por email ao criar cadastro', key: 'enable_send_credentials' },
        { label: 'Auto Impressão de recibos', key: 'enable_auto_print' },
        { label: 'Abrir recibos após vendas', key: 'enable_open_receipt' },
        { label: "Habilitar 'Confirmar Depois' ao criar nova venda", key: 'enable_confirm_payment_later' },
        { label: 'Confirmação de Finalização para pedidos', key: 'enable_confirm_ordercompletion' },
    ];

    const handleToggle = (field) => {
        setClientPreferences(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const handleSavePin = async () => {
        try {
            await ClientService.updateClientAdminPreferences({
                ...clientPreferences,
                pin: newPin
            });

            setClientPreferences(prev => ({ ...prev, pin: newPin }));
            setIsEditingPin(false);
            toast.success("PIN salvo com sucesso!");
        } catch (error) {
            console.error("Erro ao atualizar PIN:", error);
            toast.error("Erro ao salvar PIN!");
        }
    };

    return (
        <div className="flex flex-col gap-6">
            {/* PIN Section */}
            <div>
                <p className="flex text-xl text-custom_gray_font font-bold mb-4">
                    PIN de Administrador
                </p>
                <div className="flex flex-col bg-white rounded-2xl shadow p-4 max-w-lg">
                    <label className="text-custom_gray_font mb-2">PIN</label>
                    <div className="flex items-center gap-4">
                        <input
                            type={showPin ? "text" : "password"}
                            value={clientPreferences.pin || ''}
                            readOnly
                            className="w-full px-4 py-2 border rounded-xl text-custom_gray_font bg-gray-50"
                        />
                        <button
                            type="button"
                            onClick={() => setShowPin(!showPin)}
                            className="text-sm text-custom_blue min-w-[60px]"
                        >
                            {showPin ? "Ocultar" : "Mostrar"}
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                setNewPin(clientPreferences.pin || "");
                                setIsEditingPin(true);
                            }}
                            className="px-4 py-2 bg-custom_blue text-white rounded-xl hover:bg-blue-600 transition"
                        >
                            Editar
                        </button>
                    </div>
                </div>
            </div>

            {/* General Toggles Section */}
            <div>
                <p className="flex text-xl text-custom_gray_font font-bold mb-4">
                    Preferências Gerais
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {toggleFields.map(({ label, key }) => (
                        <div key={key} className="flex items-center justify-between bg-white rounded-2xl shadow p-4">
                            <span className="text-custom_gray_font font-semibold">{label}</span>
                            <Switch
                                checked={!!clientPreferences[key]}
                                onChange={() => handleToggle(key)}
                                className={`${clientPreferences[key] ? 'bg-custom_blue' : 'bg-gray-300'}
                                relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none`}
                            >
                                <span
                                    className={`${clientPreferences[key] ? 'translate-x-6' : 'translate-x-1'}
                                    inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                                />
                            </Switch>
                        </div>
                    ))}
                </div>
            </div>

            {/* PIN MODAL */}
            <Transition appear show={isEditingPin} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={() => setIsEditingPin(false)}>
                    <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </TransitionChild>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                                <DialogPanel className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl text-left align-middle transform transition-all">
                                    <Dialog.Title className="text-lg font-medium leading-6 text-gray-900">
                                        Editar PIN do Administrador
                                    </Dialog.Title>
                                    <div className="mt-4">
                                        <input
                                            type="text"
                                            className="w-full px-4 py-2 border rounded-xl focus:ring-2 focus:ring-custom_blue focus:outline-none"
                                            value={newPin}
                                            onChange={(e) => setNewPin(e.target.value)}
                                            placeholder="Novo PIN"
                                        />
                                    </div>
                                    <div className="mt-6 flex justify-end gap-4">
                                        <button
                                            onClick={() => setIsEditingPin(false)}
                                            className="px-4 py-2 rounded-xl border hover:bg-gray-50"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={handleSavePin}
                                            className="px-4 py-2 bg-custom_green text-white rounded-xl hover:bg-green-600"
                                        >
                                            Salvar PIN
                                        </button>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    );
};

export default PreferencesTab;